import { Scope } from "@corpuscomplete/core/common/scope";

const STORAGE_KEY_PREFIX = "cc:lastScopedRouteScope:";
const SCOPED_SECTIONS = "(?:collections|meal-planning-sessions|planned-meals|recipes)";
const personalScopedRoutePattern = new RegExp(`^/personal/${SCOPED_SECTIONS}(?:/|$)`);
const spaceScopedRoutePattern = new RegExp(`^/spaces/([^/]+)/${SCOPED_SECTIONS}(?:/|$)`);

export function getScopedRouteScopeFromPathname(
  pathname: string,
  userId: string,
): Scope.Info | null {
  if (personalScopedRoutePattern.test(pathname)) {
    return Scope.personal(userId);
  }

  const spaceMatch = pathname.match(spaceScopedRoutePattern);
  const spaceId = spaceMatch?.[1];
  if (spaceId) {
    return Scope.space(spaceId);
  }

  return null;
}

export function readLastScopedRouteScope(userId: string): Scope.Info {
  if (typeof window === "undefined") {
    return Scope.personal(userId);
  }

  try {
    const raw = window.localStorage.getItem(storageKey(userId));
    if (!raw) {
      return Scope.personal(userId);
    }

    const parsed = Scope.schema.safeParse(JSON.parse(raw));
    if (parsed.success) {
      return parsed.data;
    }

    window.localStorage.removeItem(storageKey(userId));
  } catch {
    try {
      window.localStorage.removeItem(storageKey(userId));
    } catch {
      return Scope.personal(userId);
    }
  }

  return Scope.personal(userId);
}

export function writeLastScopedRouteScope(userId: string, scope: Scope.Info): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(storageKey(userId), JSON.stringify(scope));
  } catch {
    return;
  }
}

function storageKey(userId: string): string {
  return `${STORAGE_KEY_PREFIX}${userId}`;
}
